import { Expose } from 'class-transformer'
import { PaymentTrueMoneyStatusEnum } from '@interfaces/PaymentTrueMoneyStatusEnum'

export class ConfirmPaymentTrueMoneyType {
  @Expose() status: PaymentTrueMoneyStatusEnum
}
